import { useState } from "react";

import { SecurityCodeForm } from "./SecurityCodeForm";

import { useAuth } from "../../../../hooks/useAuth";

const initialValues = {
  0: "",
  1: "",
  2: "",
  3: "",
  4: "",
  5: "",
};

const SecurityCode = () => {
  const [enteredCode, setEnteredCode] = useState(initialValues);

  const { handleResendCodeVerification, handleSecurityCodeSubmit } = useAuth();

  const handleChangeCodeVerification = (index, value) => {
    if (index > 5) return;

    setEnteredCode((prevValues) => {
      return {
        ...prevValues,
        [index]: value ? value[0] : "",
      };
    });

    if (value !== "" && index < 5) {
      const nextInput = document.getElementById(`input-${index + 1}`);
      nextInput.focus();
    }

    if (value === "" && index > 0) {
      const previousInput = document.getElementById(`input-${index - 1}`);
      previousInput.focus();
    }
  };

  const onSecurityCodeSubmit = async (formProps) => {
    await handleSecurityCodeSubmit(formProps);
    setEnteredCode(initialValues);
  };

  const onResendCodeVerification = async (setSubmitting) => {
    await handleResendCodeVerification(setSubmitting);
    setEnteredCode(initialValues);
  };

  const securityCodeProps = {
    initialValues: enteredCode,
    onSubmit: onSecurityCodeSubmit,
    enteredCode: enteredCode,
    onChangeVerificationCode: handleChangeCodeVerification,
    onResendCodeVerification: onResendCodeVerification,
  };

  return <SecurityCodeForm {...securityCodeProps} />;
};

export default SecurityCode;
